<template>
	<view class="shop">
		<!-- 头部视频 -->
		<view class="shop_video">
			<video id="myVideo" :src="videoUrl" enable-danmu danmu-btn controls></video>
		</view>
		<!-- 店铺信息 -->
		<view class="shop_info">
			<view class="shop_info_user">
				<view class="shop_info_user_left" @click="jumpUser">
					<image src="@/static/logo.png" mode="widthFix"></image>
					<view class="shop_info_user_left_name">
						<text>林之秋</text>
						<text>2022-12-04 13:51</text>
					</view>
				</view>
				<view class="shop_info_user_right"><text>关注</text></view>
			</view>
			<view class="shop_info_title">
				如何制作有韧劲的生椰拿铁太妃糖？
			</view>
			<view class="shop_info_desc">
				一进门就是浓郁的复古电影质感，每一处都体现得优雅，
				以及高级复古！从中古桌椅到灯饰、碎花窗帘、复古杯
				具...每一处都好用心。
				二楼还有一柜子的书可以看，很愜意！环境超安静的，
				很适合看书办公！点咖啡还会送一块蛋糕三栗子蛋糕很
				好吃。
			</view>
			<StoreInformation :info="info" @getId="jump" />
		</view>
		<!-- 相关视频 -->
		<view class="shop_list">
			<text class="shop_list_title">相关推荐</text>
			<scroll-view scroll-x="true" class="shop_list_video">
				<view class="shop_list_video_item">
					<image src="@/static/icon/img_baike@2x.png" mode="widthFix"></image>
					<view class="shop_list_video_item_wz">
						<text>热带雨林，让你体验到不一般的墨西哥你体验到不一般的墨西哥</text>
					</view>
				</view>
				<view class="shop_list_video_item">
					<image src="@/static/icon/img_baike@2x.png" mode="widthFix"></image>
					<view class="shop_list_video_item_wz">
						<text>热带雨林，让你体验到不一般的墨西哥你体验到不一般的墨西哥</text>
					</view>
				</view>
				<view class="shop_list_video_item">
					<image src="@/static/icon/img_baike@2x.png" mode="widthFix"></image>
					<view class="shop_list_video_item_wz">
						<text>热带雨林，让你体验到不一般的墨西哥你体验到不一般的墨西哥</text>
					</view>
				</view>
			</scroll-view>
		</view>
		<!-- 评论 -->
		<view class="shop_comment">
			<view class="comment_title">精彩评论</view>
			<view class="comment_list">
				<view class="comment_list_item">
					<image src="@/static/uni.png" mode="widthFix"></image>
					<view class="comment_list_item_info">
						<text class="comment_list_item_info_name">小猪佩奇</text>
						<text class="comment_list_item_info_remak">有感而发，大家可以积极讨论</text>
						<view class="comment_list_item_info_z">
							<text>11-27</text>
							<view class="z_box">
								<image src="@/static/logo.png" mode="widthFix"></image>
								<text>2</text>
							</view>
						</view>
						<view class="comment_child">
							<view class="comment_list_item">
								<image src="@/static/uni.png" mode="widthFix"></image>
								<view class="comment_list_item_info">
									<text class="comment_list_item_info_name">小猪佩奇</text>
									<text class="comment_list_item_info_remak">有感而发，大家可以积极讨论</text>
									<view class="comment_list_item_info_z">
										<text>11-27</text>
										<view class="z_box">
											<image src="@/static/logo.png" mode="widthFix"></image>
											<text>2</text>
										</view>
									</view>
									<view class="comment_list_item_info_gd">
										<text>展开2条回复</text>
										<image src="@/static/icon/pinglun_ic_more@2x.png" mode="widthFix"></image>
									</view>
								</view>
							</view>
						</view>
					</view>
				</view>
			</view>
		</view>
		<!-- 操作 -->
		<view class="shop_operate">
			<view class="shop_operate_ipt">
				<input type="text" placeholder="说点什么吧" placeholder-style="font-size: 24rpx; color: #999999; font-weight: 400;" />
			</view>
			<view class="shop_operate_list">
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_pinglun@2x.png" mode="widthFix"></image>
					<text>评论</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_dianzan@2x.png" mode="widthFix"></image>
					<!-- <image src="@/static/icon/Group 1049@2x.png" mode="widthFix"></image> -->
					<text>点赞</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_shoucang@2x.png" mode="widthFix"></image>
					<!-- <image src="@/static/icon/ic_shoucang_sel@2x.png" mode="widthFix"></image> -->
					<text>收藏</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_fenxiang@2x(1).png" mode="widthFix"></image>
					<text>分享</text>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	import StoreInformation from '@/components/StoreInformation/index.vue'
	export default {
		data() {
			return {
				info: {
					img: require('@/static/uni.png'),
					name: '42coffee',
					divide: 5,
					address: '上海市闵行区申虹路'
				},
				videoUrl: 'https://img.cdn.aliyun.dcloud.net.cn/guide/uniapp/%E7%AC%AC1%E8%AE%B2%EF%BC%88uni-app%E4%BA%A7%E5%93%81%E4%BB%8B%E7%BB%8D%EF%BC%89-%20DCloud%E5%AE%98%E6%96%B9%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B@20200317.mp4'
			}
		},
		components: { StoreInformation },
		methods: {
			jump(id) {
				console.log(id)
			},
			jumpUser() {
				uni.navigateTo({
					url: '/pages/authorHomepage/index'
				});
			}
		}
	}
</script>

<style>
	page {
		background-color: #F5F5F5 !important;
	}
</style>

<style lang="scss" scoped>
	.shop {
		width: 100%;
		// padding-bottom: calc(env(safe-area-inset-bottom) + 85rpx);
		.shop_video {
			width: 100%;
			height: 420rpx;
			video {
				width: 100%;
				height: 100%;
			}
		}
		.shop_info {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.shop_info_user {
				display: flex;
				align-items: center;
				justify-content: space-between;
				.shop_info_user_left {
					display: flex;
					align-items: center;
					height: 72rpx;
					image {
						width: 72rpx;
						height: 100%;
						border-radius: 50%;
						margin-right: 28rpx;
					}
					.shop_info_user_left_name {
						display: flex;
						flex-direction: column;
						height: 100%;
						justify-content: space-between;
						text {
							&:nth-child(1) {
								font-size: 28rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #333333;
							}
							&:nth-child(2) {
								font-size: 20rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #999999;
							}
						}
					}
				}
				.shop_info_user_right {
					width: 128rpx;
					height: 48rpx;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 27rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
					}
				}
			}
			.shop_info_title {
				font-size: 36rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-top: 24rpx;
			}
			.shop_info_desc {
				font-size: 28rpx;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				margin-top: 20rpx;
				margin-bottom: 32rpx;
			}
		}
		.shop_list {
			width: 100%;
			padding: 28rpx 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.shop_list_title {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.shop_list_video {
				width: 100%;
				margin-top: 24rpx;
				white-space: nowrap;
				.shop_list_video_item {
					width: 288rpx;
					display: inline-flex;
					flex-direction: column;
					margin-right: 16rpx;
					&:last-child {
						margin-right: 0 !important;
					}
					image {
						width: 288rpx;
						height: 160rpx;
						border-radius: 10rpx;
					}
					.shop_list_video_item_wz {
						margin-top: 14rpx;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						overflow: hidden;
						text-overflow: ellipsis;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
					}
				}
			}
		}
		.shop_comment {
			width: 100%;
			margin-top: 16rpx;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.comment_title {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 24rpx;
			}
			.comment_list {
				width: 100%;
				.comment_list_item {
					display: flex;
					padding-bottom: 28rpx;
					box-sizing: border-box;
					border-bottom: 2rpx solid #F4F5F4;
					image {
						width: 64rpx;
						height: 64rpx;
						flex-shrink: 0;
						margin-right: 16rpx;
						border-radius: 50%;
					}
					.comment_list_item_info {
						flex: 1;
						display: flex;
						flex-direction: column;
						.comment_list_item_info_name {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
						}
						.comment_list_item_info_remak {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							margin: 16rpx 0 12rpx 0;
						}
						.comment_list_item_info_z {
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-bottom: 28rpx;
							text {
								font-size: 24rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #999999;
							}
							.z_box {
								display: flex;
								align-items: center;
								image {
									width: 28rpx;
									height: 28rpx;
									margin-right: 8rpx;
								}
								text {
									font-size: 24rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #999999;
								}
							}
						}
						.comment_child {
							.comment_list_item {
								display: flex;
								border: none;
								padding-bottom: 0;
								image {
									width: 64rpx;
									height: 64rpx;
									flex-shrink: 0;
									margin-right: 16rpx;
									border-radius: 50%;
								}
								.comment_list_item_info {
									flex: 1;
									display: flex;
									flex-direction: column;
									.comment_list_item_info_name {
										font-size: 24rpx;
										font-family: PingFang SC-Regular, PingFang SC;
										font-weight: 400;
										color: #999999;
									}
									.comment_list_item_info_remak {
										font-size: 28rpx;
										font-family: PingFang SC-Medium, PingFang SC;
										font-weight: 500;
										color: #333333;
										margin: 16rpx 0 12rpx 0;
									}
									.comment_list_item_info_z {
										display: flex;
										align-items: center;
										margin-bottom: 0;
										justify-content: space-between;
										text {
											font-size: 24rpx;
											font-family: PingFang SC-Regular, PingFang SC;
											font-weight: 400;
											color: #999999;
										}
										.z_box {
											display: flex;
											align-items: center;
											image {
												width: 28rpx;
												height: 28rpx;
												margin-right: 8rpx;
											}
											text {
												font-size: 24rpx;
												font-family: PingFang SC-Medium, PingFang SC;
												font-weight: 500;
												color: #999999;
											}
										}
									}
									.comment_list_item_info_gd {
										display: flex;
										align-items: center;
										margin-top: 20rpx;
										text {
											font-size: 24rpx;
											font-family: PingFang SC-Semibold, PingFang SC;
											font-weight: 600;
											color: #666666;
										}
										image {
											width: 20rpx;
											height: 12rpx;
											margin-left: 4rpx;
										}
									}
								}
							}
						}
					}
				}
			}
		}
		.shop_operate {
			width: 100%;
			padding: 16rpx 32rpx calc(env(safe-area-inset-bottom) + 16rpx) 32rpx;
			box-sizing: border-box;
			background-color: #FFFFFF;
			border: 2rpx solid #F4F5F4;
			position: sticky;
			bottom: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.shop_operate_ipt {
				width: 368rpx;
				height: 64rpx;
				line-height: 64rpx;
				background: #F5F4F5;
				border-radius: 32rpx;
				padding: 0 26rpx;
				box-sizing: border-box;
				input {
					width: 100%;
					height: 100%;
					font-size: 24rpx;
					color: black;
				}
			}
			.shop_operate_list {
				flex: 1;
				display: flex;
				align-items: center;
				.shop_operate_list_item {
					flex: 1;
					display: flex;
					align-items: center;
					flex-direction: column;
					image {
						width: 30rpx;
						height: 30rpx;
						margin-bottom: 8rpx;
					}
					text {
						font-size: 16rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
			}
		}
	}
</style>